export interface NonGatedPcpData {
  providerID?: string;
  providerType?: string;
  providerName?: string;
  pcpId?: string;
}

export interface NonGatedPcpState {
  nonGatedPrimaryCareData: NonGatedPcpData;
  hasFetchedNonGatedPrimaryCareData: boolean;
  setNonGatedPrimaryCareData: (values: NonGatedPcpData) => void;
  clearNonGatedPrimaryCareData: () => void;
  setHasFetchedNonGatedPrimaryCareData: (value: boolean) => void;
}

export enum StoreKeys {
  NON_GATED_PRIMARY_CARE_DATA = 'nonGatedPrimaryCareData',
  HAS_FETCHED_NON_GATED_PRIMARY_CARE_DATA = 'hasFetchedNonGatedPrimaryCareData',
  SET_NON_GATED_PRIMARY_CARE_DATA = 'setNonGatedPrimaryCareData',
  CLEAR_NON_GATED_PRIMARY_CARE_DATA = 'clearNonGatedPrimaryCareData',
  SET_HAS_FETCHED_NON_GATED_PRIMARY_CARE_DATA = 'setHasFetchedNonGatedPrimaryCareData',
}

export const initialState = {
  [StoreKeys.NON_GATED_PRIMARY_CARE_DATA]: {},
  [StoreKeys.HAS_FETCHED_NON_GATED_PRIMARY_CARE_DATA]: false,
};
